<input tuiLike type="checkbox" size="s" [ngModel]="!darkMode()" (ngModelChange)="onThemeChange($event)" />
